module.exports = __webpack_public_path__ + "static/img/logout-icon.953f910.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logout-icon.png
// module id = OLLs
// module chunks = 2